import { zBaseSchemaCreateDom, zBaseSchemaDom, } from "@/types/base/base.domain";
import { zBaseSchemaCreateDto, zBaseSchemaDto, } from "@/types/base/base.dto";
import { AddressInfo } from "@/types/zAddressInfo";
export const BaseMapper = {
    /**
     * Преобразование из DTO (плоская структура) в Domain (с инкапсулированным addressInfo)
     */
    toDomain: (dto) => {
        // Validate the base fields
        const safeDto = zBaseSchemaDto.parse(dto);
        // Create AddressInfo instance from DTO data
        const addressInfo = AddressInfo.fromPlainObject(safeDto);
        /**
         * сначала парсим плоскую структуру, затем инкапсулируем в AddressInfo
         * это нужно, чтобы убедиться, что все поля адреса валидны
         */
        const baseFields = zBaseSchemaDom.parse({
            ...safeDto,
            addressInfo: addressInfo.toPlainObject(),
        });
        return {
            ...baseFields,
            addressInfo,
        };
    },
    /**
     * Преобразование из Domain (с AddressInfo) в DTO (плоская структура)
     */
    toDto: (domain) => {
        const safeDomain = zBaseSchemaDom.parse(domain);
        // Extract address data from AddressInfo class (internal use)
        return zBaseSchemaDto.parse({
            ...safeDomain,
            ...domain.addressInfo.toPlainObject(),
        });
    },
    /**
     * Преобразование из Domain (с AddressInfo) в DTO (плоская структура) для создания
     */
    toCreateBaseDto: (domain) => {
        const safeDomain = zBaseSchemaCreateDom.parse(domain);
        const { addressInfo, ...rest } = safeDomain;
        const dto = {
            ...rest,
            ...addressInfo,
        };
        return zBaseSchemaCreateDto.parse(dto);
    },
};
